import { React } from 'react';
import styled from 'styled-components';

import ProgramView from '../../Model/Individual/NoteModel/ProgramView';

function ProgramPage () {

  return (
    <Container>
      <ProgramView/>
    </Container>
  )
}

export default ProgramPage;

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;